import React, { useRef, useState } from "react";
import { useSubmitAssignmentMarkMutation } from "../../features/assignments/assignemntsApi";

export default function SingleAssignmentMarking({ assignmentMark }) {
  const markRef = useRef();
  const {
    student_name,
    title,
    repo_link,
    id: assignmentId,
    createdAt,
    totalMark,
    status,
    mark,
  } = assignmentMark;
  const fulldate = new Date(createdAt);
  const [isCopied, setIsCopied] = useState(false);
  const [submitAssignmentMark] = useSubmitAssignmentMarkMutation();

  const getDate = () => {
    const month = fulldate.toLocaleString("default", { month: "short" });
    const day = fulldate.getDate();
    const year = fulldate.getFullYear();
    const hour = fulldate.getHours();
    const minute = fulldate.getMinutes();
    const second = fulldate.getSeconds();
    const meridiem = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${day} ${month} ${year} ${hour12}:${minute}:${second} ${meridiem}`;
  };

  const inputMarking = (event) => {
    let { value, min, max } = event.target;
    value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    markRef.current.value = value;
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
  };

  const handleMarking = () => {
    const data = {
      mark: Number(markRef?.current.value),
      status: "published",
    };
    submitAssignmentMark({ id: assignmentId, data });
  };

  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{getDate()}</td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">
        <p
          title="Click to copy the full url"
          onClick={(e) => handleCopy(repo_link)}
          className="cursor-pointer"
        >
          {repo_link.substring(0, 35)}...
          <span className="text-violet-600">
            {" "}
            {isCopied ? "Copied" : "Copy"}
          </span>
        </p>
      </td>
      <td className="table-td input-mark">
        {status === "pending" && (
          <input
            onChange={inputMarking}
            type="number"
            ref={markRef}
            max={totalMark}
            defaultValue={totalMark}
            className="appearance-none"
          />
        )}
        {status === "published" && <span>{mark}</span>}
        {status === "pending" && (
          <button onClick={status === "pending" ? handleMarking : () => {}}>
            <svg
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
              />
            </svg>
          </button>
        )}
      </td>
    </tr>
  );
}
